import React, {Component} from 'react';
import { Player } from 'video-react';
import { Link } from 'react-scroll';

import { maxMobileWidth } from '../../helpers/constans';

import './styles/main-video.scss';

export default class MainVideo extends Component {

  constructor(props) {
    super();

    this.state = {
      startVideo: false,
      mutedVideo: true,
    }
  }

  componentDidMount() {
    // subscribe state video change

    setTimeout(() => {
      this.setState({ 
        startVideo : true 
      }, () => {
        this.player.subscribeToStateChange(this.handleVideoStateChange.bind(this));
      })
    }, 2000)
  }

  handleVideoStateChange(state, prevState) {
    if (state.paused && !prevState.paused && this.state.mutedVideo) {
      this.setState({
        mutedVideo: false,
      })
    }
  }

  render() {

    const {
      textVisible,
    } = this.props;

    return(
      <div className="mainVideo">
        {
          this.state.startVideo
          ? <div className="mainVideo__video">
              <Player
                ref={(player) => { this.player = player }}
                playsInline
                autoPlay
                loop
                muted={this.state.mutedVideo}
                preload="auto"
                poster={window.innerWidth < maxMobileWidth ? require('../../static/images/main-video/poster-mobile.jpg').default : require('../../static/images/main-video/poster.jpg').default}
                src={require('../../static/video/main-video.mp4').default}
              />
            </div>
          : <div className="mainVideo__img"></div>
        }
        <div className="mainVideo__logo">
          <img src={require('../../static/images/logo.svg').default} alt="logo" />
        </div>
        <div className="mainVideo__link">
          <Link
            to="wearCollection"
            smooth={true}
            duration={800}
          >Composition & Care</Link>
        </div>
        <div className={`mainVideo__title ${textVisible ? '' : '_hidden'}`}>
          <h1>Introducing Do Deep Tech Garments</h1>
        </div>
        <div className={`mainVideo__desc ${textVisible ? '' : '_hidden'}`}>
          <p>"Do&nbsp;Deep Tech" is&nbsp;one of&nbsp;our core values. It&rsquo;s not just about what we&nbsp;do&nbsp;&mdash; it&rsquo;s about how we&nbsp;look. That&rsquo;s why we&nbsp;decided to&nbsp;create our very first collection of&nbsp;WayRay clothing, bringing our vision of&nbsp;Deep Tech to&nbsp;fashion.</p>
          <p>Do&nbsp;Deep Tech Garments are the new standard in&nbsp;clothing. They&rsquo;re ethical and help reduce consumption because of&nbsp;their versatility, quality and durability. Thoughtful, functional and comfortable, these items are a&nbsp;versatile uniform to&nbsp;be&nbsp;proud&nbsp;of.</p>
        </div>
        {/* <div className="container-inner">
          <div className={`mainVideo__title ${textVisible ? '' : '_hidden'}`}>
            <h1>Introducing Do Deep Tech Garments</h1>
          </div>
          <div className={`mainVideo__desc ${textVisible ? '' : '_hidden'}`}>
            <p>"Do&nbsp;Deep Tech" is&nbsp;one of&nbsp;our core values. It&rsquo;s not just about what we&nbsp;do&nbsp;&mdash; it&rsquo;s about how we&nbsp;look. That&rsquo;s why we&nbsp;decided to&nbsp;create our very first collection of&nbsp;WayRay clothing, bringing our vision of&nbsp;Deep Tech to&nbsp;fashion.</p>
            <p>Do&nbsp;Deep Tech Garments are the new standard in&nbsp;clothing. They&rsquo;re ethical and help reduce consumption because of&nbsp;their versatility, quality and durability. Thoughtful, functional and comfortable, these items are a&nbsp;versatile uniform to&nbsp;be&nbsp;proud&nbsp;of.</p>
          </div>
        </div> */}
      </div>
    )
  }
}